import * as v from "valibot";
import { rpcContract } from "../rpc";

/**
 * Get checkout session status
 * Called after user returns from Stripe Checkout to verify payment completion
 * Used to show success/failure message and grant access
 */
export const getCheckoutStatusRpcContract = rpcContract({
  name: "get-checkout-status",
  paramsSchema: v.object({
    sessionId: v.string(),
  }),
  resultSchema: v.object({
    status: v.picklist(["pending", "complete", "failed", "expired"]),
    checkoutType: v.optional(v.picklist(["subscription", "one_time_purchase"])),
  }),
});

export type GetCheckoutStatusParams = v.InferOutput<(typeof getCheckoutStatusRpcContract)["paramsSchema"]>;
export type GetCheckoutStatusResult = v.InferOutput<(typeof getCheckoutStatusRpcContract)["resultSchema"]>;
